import { da, de, enGB, enUS, es, et, fi, fr, lt, lv, it, nb, nl, pl, sv, ca, cs, hr, pt, ro, tr } from 'date-fns/locale';
import { CountryOption, Translations } from '../redux/types';
import { Locale } from 'date-fns/locale/types';
import { h } from '@stencil/core';

const emptyStringForKeysWhenNoTranslation = ['inventory.offerTitle', 'inventory.offerDescription'];

// example of key "legal.term:49b4400a-5131-411c-6a52-8486b608fb90"
export function trans(key: string, locale: string, translations: Translations, params = {}, fallback = ''): string {
  const spKey = key.split('.');
  if (spKey.length !== 2) {
    return key;
  }

  let langTranslations = translations[locale] || translations['en-GB'] || translations['en-US'];
  const category = langTranslations ? langTranslations[spKey[0]] : null;
  const text = category && category[spKey[1]];
  // empty string is a valid translation text
  if (text === undefined || text === null) {
    for (const keyPrefix of emptyStringForKeysWhenNoTranslation) {
      if (key.startsWith(keyPrefix)) {
        return '';
      }
    }

    return fallback ? fallback : key;
  }

  return replaceVariables(text, params);
}

function replaceVariables(str, params = {}): string {
  const regexp = /%{([^%{]+)}/g;

  return str.replace(regexp, function (_, key) {
    return (key = params[key]) == null ? '' : key;
  });
}

export function stepKey(stepId: string): string {
  return `steps.stepName:${stepId}`;
}

export function stepDescription(stepId: string): string {
  return `steps.stepDescription:${stepId}`;
}

export function itemKey(offerId: string): string {
  return `inventory.offerName:${offerId}`;
}

export function itemDescriptionKey(offerId: string): string {
  return `inventory.offerDescription:${offerId}`;
}

export function itemTitleKey(offerId: string): string {
  return `inventory.offerTitle:${offerId}`;
}

export function termKey(id: string): string {
  return `legal.term:${id}`;
}

export function billingKey(field: string): string {
  return `customerData.${field}`;
}

export function countriesList(locale: string, translations: Translations): CountryOption[] {
  const langTranslations = translations[locale] || translations['en-gb'] || translations['en-us'];

  return langTranslations.countries;
}

export function dataFormTitle(id: string): string {
  return `dataForm.dataFormTitle:${id}`;
}

export function dataFormLabel(id: string): string {
  return `dataForm.dataFormLabel:${id}`;
}

export function dataFormDescription(id: string): string {
  return `dataForm.dataFormDescription:${id}`;
}

export function dataFormFieldLabel(id: string): string {
  return `dataForm.dataFormFieldLabel:${id}`;
}

export function dataFormFieldDescription(id: string): string {
  return `dataForm.dataFormFieldDescription:${id}`;
}

export function dataFormFieldOptionValueKey(id: string): string {
  return `dataForm.dataFormFieldOptionValue:${id}`;
}

export const localeToFnsLocale = (systemLocale: string): Locale => {
  // reflects all backend languages
  const fnsLocales = [ca, cs, da, de, enGB, enUS, es, et, fi, fr, hr, it, lt, lv, nb, nl, pl, pt, ro, sv, tr];

  if (!systemLocale) {
    return enGB;
  }

  const firstCode = systemLocale.split('-')[0];

  if (firstCode === 'en') {
    return fnsLocales.find((fnsLocale: Locale) => fnsLocale.code === systemLocale);
  }

  return fnsLocales.find((fnsLocale: Locale) => fnsLocale.code === firstCode);
};

export const addAtrToTranslation = ({ translation, splitChar, attributes }: { translation: string; splitChar: string; attributes: object }): Node => {
  const splitText = translation.split(splitChar);

  if (splitText.length !== 3) {
    return <span>{translation}</span>;
  }

  return (
    <span>
      {splitText[0]}
      <span {...attributes}>{splitText[1]}</span>
      {splitText[2]}
    </span>
  );
};
